import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from "../../../../ui/FormElement";
import { useAdminContext } from "../../../../contexts/AdminContext";

export default function Form() {
  let FormSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().required("Email is required"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useAdminContext();

  const [formData, setFormData] = useState(
    state.currentUser == null
      ? {
          firstName: "",
          lastName: "",
          email: "",
          password: "",
        }
      : {
          firstName: state.currentUser.attributes.first_name,
          lastName: state.currentUser.attributes.last_name,
          email: state.currentUser.attributes.email,
          password: "",
        }
  );

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.saveAdmin(
      dispatch,
      state.currentUser == null ? 0 : parseInt(state.currentUser.id),
      values,
      () => {
        setLoader(false);
        actions.hideModal(dispatch);
        actions.loadAdmins(dispatch);
      },
      (errorData) => {
        let newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace("/data/attributes/", "")] =
            item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      }
    );
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="firstName"
        label={
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="lastName"
        label={
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="email"
        type="email"
        label={
          <>
            <span>E-Mail</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="password"
        type="password"
        label={
          <>
            <span>Password</span>
            {state.currentUser == null && <abbr title="required">*</abbr>}
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Send"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
